import { Box, Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const FooterAll = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				padding: window.innerWidth > 600 ? "8vh 0" : "2vh 1vh",
			}}
		>
			<Container>
				<Grid container spacing={2}>
					<Grid md={2} xs={0}></Grid>
					<Grid md={4} xs={12}>
						<a
							className="footer_url"
							style={{ color: "#fff", cursor: "pointer" }}
							onClick={() => navigate("terms-condition")}
							target="_blank"
						>
							{t("footer.termsOfUse")}
						</a>
					</Grid>
					<Grid md={4} xs={12}>
						<a
							className="footer_url"
							style={{ color: "#fff", cursor: "pointer" }}
							onClick={() => navigate("privacy-policy")}
							target="_blank"
						>
							{t("footer.privacyPolicy")}
						</a>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};
